/** Your loop's tempo + key on the finished song's timeline: keep the loop's BPM and key, and find where its beats
 *  fall in the song (the beat phase with the most note onsets over the first 30 s). */
const RATE = 200;

function onsets(buffer, maxSec) {
  const d = buffer.getChannelData(0);
  const hop = Math.max(1, Math.round(buffer.sampleRate / RATE));
  const rate = buffer.sampleRate / hop;
  const n = Math.min(Math.floor(d.length / hop), Math.round(maxSec * rate));
  const out = new Float32Array(n);
  let prev = 0;
  for (let i = 0; i < n; i += 1) {
    let s = 0;
    for (let j = i * hop; j < (i + 1) * hop; j += 1) s += d[j] * d[j];
    const e = Math.sqrt(s / hop);
    out[i] = Math.max(0, e - prev);
    prev = e;
  }
  return { on: out, rate };
}

/** First-beat offset (s, within one beat) of a `bpm` grid that best fits the song. */
export function beatPhase(song, bpm, seconds = 30) {
  const { on, rate } = onsets(song, seconds);
  const period = (60 / bpm) * rate;
  let best = 0;
  let bestScore = -1;
  for (let ph = 0; ph < period; ph += 1) {
    let s = 0;
    for (let t = ph; t < on.length; t += period) s += on[Math.round(t)] || 0;
    if (s > bestScore) { bestScore = s; best = ph; }
  }
  return best / rate;
}

export function tempoInSong(loopTempo, song) {
  return { bpm: loopTempo.bpm, offset: Math.round(beatPhase(song, loopTempo.bpm) * 1000) / 1000, tonic: loopTempo.tonic ?? null,
    mode: loopTempo.mode || "major", source: loopTempo.source === "manual" ? "manual" : "auto", confidence: loopTempo.confidence || 0 };
}
